import React, { useState } from "react";
import { Card, Divider, Typography, Select } from "antd";
import { useNavigate } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import BulkOutwardPreview from "../../../components/DispatchCentre/BlukOutward/Bin/Preview/BulkOutwardPreview";
import "../../../styles/global-ui.css";

const { Option } = Select;

const OutwardPreviewPage = () => {
  const navigate = useNavigate();
  const [selectedBatch, setSelectedBatch] = useState(null);

  const batches = ["BATCH 1", "BATCH 2", "BATCH 3", "BATCH 4", "BATCH 5"];

  const handleArrowClick = () => {
    navigate(-1);
  };

  const handleBatchChange = (value) => {
    setSelectedBatch(value);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <ArrowLeftOutlined
                onClick={handleArrowClick}
                style={{ cursor: "pointer" }}
              />
              Preview Outward Bins
            </span>
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Review selected bins before confirming outward movement
          </Typography.Text>
        </div>

        <Select
          showSearch
          placeholder="Select a batch"
          optionFilterProp="children"
          onChange={handleBatchChange}
          value={selectedBatch}
          style={{ width: 220 }}
          filterOption={(input, option) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {batches.map((batch) => (
            <Option key={batch} value={batch}>
              {batch}
            </Option>
          ))}
        </Select>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <BulkOutwardPreview selectedBatch={selectedBatch} />
      </Card>
    </div>
  );
};

export default OutwardPreviewPage;